import { render, staticRenderFns } from "./SignInPage.vue?vue&type=template&id=2dabb220&scoped=true&"
import script from "./SignInPage.vue?vue&type=script&lang=ts&"
export * from "./SignInPage.vue?vue&type=script&lang=ts&"
import style0 from "./SignInPage.vue?vue&type=style&index=0&id=2dabb220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dabb220",
  null
  
)

export default component.exports